export enum MenuTitle
{    
    ORGANIZATION        =   "menu.title.organization_detail"    ,
    SITE                =   "menu.title.site_detail"            ,
    DASHBOARD           =   "menu.title.dashboard"              ,
    STATISTIC           =   "menu.title.statistic"              ,
    PROGRESS_MODE       =   "menu.title.progressmode"           ,
    TIMESTABLE          =   "menu.title.timestable"             ,
    TIMESTABLE_DEVICE   =   "menu.title.timedevice"             ,
    TIMESTABLE_SERVICE  =   "menu.title.timeservice"            ,
    SLOTAUTOMATE        =   "menu.title.slotautomate"           ,
    OPERATOR            =   "menu.title.operator"               ,
    DEVICE_SERVICE      =   "menu.title.deviceservice"          ,
    OPERATOR_COUNTER    =   "menu.title.operatorcounter"        ,
    ASSIGN_OPERATOR     =   "menu.title.assignoperator"         ,
    DEVICE              =   "menu.title.device"                 ,
    MANAGEMENT_MESSAGE  =   "menu.title.management.message"     , 
    MANAGEMENT_SERVICE  =   "menu.title.management.service"     , 
    MANAGEMENT_DEVICE   =   "menu.title.management.device"      ,
    MANAGEMENT_OPERATOR =   "menu.title.management.operator"    , 
    MANAGEMENT_BOOKING  =   "menu.title.management.booking"     , 
    MEDIA               =   "menu.title.media.title"            , 
    MEDIA_ORG           =   "menu.title.media.org"              , 
    MEDIA_SITE          =   "menu.title.media.site"             , 
    MEDIA_SERVICE       =   "menu.title.media.service"          , 

    LICENCE             =   "menu.title.licence"
}